export interface IndexPageConfig {
  header: IndexPageHeader;
  columns: IndexPageColumn[];
}

export interface IndexPageHeader {
  title: string;
  portals?: {
    label: string;
    route: string;
  }[];
}

export interface IndexPageColumn {
  cards: IndexPageCard[];
}

export interface IndexPageCard {
  groups: IndexPageGroup[];
}

export interface IndexPageGroup {
  label: string;
  views: IndexPageView[];
}

export interface IndexPageView {
  label: string;
  route: string;
  actions: IndexPageAction[];
}

export interface IndexPageAction {
  label: string;
  key: string;
}

export interface IndexPageArgs {
  config: IndexPageConfig;
  viewClicked?: () => void;
  actionClicked?: (args: {
    view: IndexPageView;
    action: IndexPageAction;
  }) => void;
}
